@if ((metrics$ | async).length) {
  <div class="d-flex flex-column ms-3 gapy-1">
    @for (metric of (metrics$ | async); track identify($index, metric)) {
      <ds-metric-loader
        class="d-inline-block me-1"
        [metric]="metric"
        [isListElement]="true"
        [hideLabel]="true"
      ></ds-metric-loader>
    }
  </div>
}
